import { deviceWidth } from "./device.js";
import { Swiper } from "swiper/bundle";

export function topSectionHeaderPosition() {
  let sections_pro = $(".top__projects");
  let section_label = sections_pro.find(".section__label");
  let bottom_value = sections_pro.height() - section_label.width();
  console.log(sections_pro);
  section_label.css("bottom", bottom_value);

  // let sections_his = $(".top__history");
  // let section_label__his = sections_his.find(".section__label");
  // let bottom_value__his = sections_his.height() - section_label.width();
  // console.log(sections);
  // section_label.css("bottom", bottom_value);
}

let prj_view = $(".js-prj_view");
let prj_view_anker = $(".js-prj_view_anker");
let prj_nav = $(".js-prj_nav");
let active_class = "tpj__navitem-isActive";

// console.log($(prj_nav).find('li'));

function switchItem(element) {
  // class の付け替え
  $(element).parent().find(".tpj__navitem-isActive").removeClass(active_class);
  $(element).addClass(active_class);

  

  // data- attribute の中身をobject に格納
  let prj_info = {
    name: $(element).find(".tpj__btn").attr("data-name"),
    description: $(element).find(".tpj__btn").attr("data-description"),
    url: $(element).find(".tpj__btn").attr("data-url"),
    img: $(element).find(".tpj__btn").attr("data-img"),
    img_thumb: $(element).find(".tpj__btn").attr("data-img.thumb"),
  };
  // console.log(prj_info.url)

  // $(prj_view).wrap("<div></div>")

$(prj_view_anker).attr("href",prj_info.url);

  // メインヴューのラベルと説明文に一旦隠してからのフェードいん
  $(prj_view)
    .find(".top__projects__label .name")
    .text(prj_info.name)
    .hide()
    .fadeIn();


  // mobile はコメントを出さない
  if (768 < deviceWidth().width) {
    $(prj_view)
      .find(".top__projects__label .description")
      .text(prj_info.description)
      // .css()
      .hide()
      .fadeIn();
  }

  // メイン画像を差し替え
  // $(prj_view).find(".top__projects__label a").attr("href", prj_info.url);
  $(prj_view)
    .css({ "background-image": `url(${prj_info.img})` })
    .hide()
    .fadeIn();

    
}

export function topSectionProjectCategorySwitch() {
  // 繰り返しのためのパラメータ
  let loop_count = 0;
  let loop_limit = $(prj_nav).find("li").length;
  let loop_deley = 10000;

  function setViewHeight() {
    const setHeight = $(".js-prj_view");
    $(".top__projects__view__wrapper").height(setHeight.outerHeight(true));
    // console.log(setHeight);
  }

  $(window).on("resize", function () {
    setViewHeight();
  });

  // 要素がクリックされた際に発火

  let paused = false;
  $(prj_nav)
    .find(".tpj__navitem")
    .on("mouseover", function () {
      switchItem(this);

      // クリックされたらそこから再開
      let index = $(prj_nav).find(".tpj__navitem").index(this);
      if (index >= loop_limit - 1) {
        index = 0;
      } else {
        index = index + 1;
      }
      loop_count = index;
      // console.log(index);
      setViewHeight();
      paused = true;
    });
  $(prj_nav)
    .find(".tpj__navitem")
    .on("mouseout", function () {
      paused = false;
      // console.log("leave");
    });

  // HTMLがロードされた際に発火
  $(function () {
    let active_nav = $(prj_nav).find("." + active_class);

    switchItem(active_nav);

    // 一定時間かごとにloop させる
    // 最初は１からスタートさせる
    loop_count = 1;

    const timerId = setInterval(() => {
      if (paused) {
        console.log("stoped");
        return;
      }
      switchItem($(prj_nav).find("li")[loop_count]);

      loop_count++;
      if (loop_count == loop_limit) {
        loop_count = 0;
      }

      // console.log(target);
    }, loop_deley);
  });
}

export function justifyHistoryLeadtext() {
  const selector_history_leadtags = {
    lines: ".section__top_history__wrapper .lines",
    lead: "div.section__top_history__wrapper div.section__leadtag",
    margin_class: "u_mr25p",
    gap: 0,
  };
  const selector_recruit_leadtags = {
    lines: ".section__top_recruit__wrapper  .section__header__inner > .lines",
    lead: ".section__top_recruit__wrapper .section__leadtag",
    margin_class: "u_mr50p",
    gap: -100,
  };

  function setLeaderTextWidth(selectorObj) {
    let lines_width = $(selectorObj.lines);
    let leader_text = $(selectorObj.lead);
    let margin_class = selectorObj.margin_class;
    let gap = selectorObj.gap;

    let leader_text_style = {
      width: $(lines_width).width() + gap,
    };

    // console.log(leader_text);
    if (768 < deviceWidth().width) {
      $(leader_text).css(leader_text_style).addClass(margin_class);
    } else {
      $(leader_text).css(leader_text_style).removeClass(margin_class);
    }
    
  }
  setLeaderTextWidth(selector_history_leadtags);
  setLeaderTextWidth(selector_recruit_leadtags);

  $(window).on("resize", function () {
    setLeaderTextWidth(selector_history_leadtags);
    setLeaderTextWidth(selector_recruit_leadtags);
    // console.log(deviceWidth())
  });
}

export function mainVidualSlider() {
  // console.log("test");

  function switchSliderMessage(){
      let message_images = $(".mv__message");
      message_images.each(function () {
        const img = $(this).find("img");
        const mobile_src = img.attr("data-mobile");
        const desktop_src = img.attr("data-desktop");
        if (deviceWidth().width <= 767) {
          img.fadeIn().attr("src", mobile_src);
        } else {
          img.attr("src", desktop_src);
        }
        // console.log($(this).find("img").attr("data-mobile"));
      });
  }

  $(function(){
    switchSliderMessage();
  })

$(window).on("resize",function(){
    switchSliderMessage();
})
  

  let info_in_mv = $(".infoInMv");
  let scroll_down = $('.scroll');

  // info_in_mv.css({"margin-bottom":- info_in_mv.height()})
  // info_in_mv.addClass("opacity_zero");
  scroll_down.addClass("add_animation");
  // console.log(scroll_down)


  const swiper = new Swiper(".mv__steps", {
    // Optional parameters
    //   direction: "vertical",
    loop: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 800,
    autoplay: {
      delay: 2500,
      stopOnLastSlide: true,
    },

    autoHeight: false,
    slidesPerView: 1,
    spaceBetween: 0,
    initialSlide: 0,
    centeredSlides: true,

    allowTouchMove: false,

    // If we need pagination
    //   pagination: {
    //     el: ".swiper-pagination",
    //   },

    // Navigation arrows
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },

    // And if we need scrollbar
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },
  })

  // swiper の autoplay が終わった後に実行
  swiper.on('autoplayStop',function(){
    // console.log('stoped')
    info_in_mv.removeClass("opacity_zero");
    scroll_down.removeClass("opacity_zero");
    scroll_down.addClass("add_animation");
  })
  
}
